import { HandySvg } from 'handy-svg';
import { useState, useEffect } from "react";
import iconCross from '../../assets/icons/svg-sprite/close-cross--small.svg';
import iconAttention from '../../assets/icons/svg-sprite/attention.svg';
import iconPointerLeft from '../../assets/icons/svg-sprite/point-arrow-left.svg';
import iconPointerRight from '../../assets/icons/svg-sprite/point-arrow-right.svg';
import Aside from '../../components/aside/Aside';
import { cards } from '../../lib/api/api';
import { Link } from "react-router-dom";
import closeBanner from "../../modules/close-banner";

const ContractData = ({ message }) => {
    const [ID, setID] = useState(0);
    const [personalInfo, setPersonalInfo] = useState({});
    const [locations, setLocations] = useState([]);
    const [cardID, setCardID] = useState('');

    useEffect(() => {
        closeBanner();
        cards.userCard()
            .then((res) => {
                setID(res[0].id);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    useEffect(() => {
        if (ID !== 0) {
            cards.card(ID)
                .then((res) => {
                    if (res.card.hasOwnProperty('ctr') && res.card.ctr !== '') {
                        setCardID(res.card.id + res.card.ctr);
                    } else {
                        setCardID(res.card.id);
                    }
                    setLocations(res.address);
                    setPersonalInfo(res);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [ID]);

    return (
        <>
            <div className="content__article-wrap">
	            <article className="step-process-article">
		            <div className="step-process-article__inner content-columns page-container">
			            <div className="step-process-article__main content-columns__main">				
                            <div className="cart__header">
                                <div className="cart__header-inner">
                                    <Link className="cart__return" to='/'>
                                        <HandySvg className="svg-icon cart__return-icon" src={iconPointerLeft} width="18" height="10"/>
                                        <span className="cart__return-text">Вернуться на главную</span>
                                    </Link>
                                    <h1 className="cart__title title title--h2">Данные договора {cardID}</h1> 
                                </div>
                            </div>
                            <div className="wysiwyg">
                                <p style={{marginBottom: 30}}>Данные договора можно изменить, обратившись в Службу поддержки!</p>
                            </div>
                            <form id="user-card-agreement" action="javascript:void(0)">
                                <div className="form__form-body">
                                    <div className="form__line">
                                        <div className="form__item form__item--md">
                                            <label for="profile_name_1" className="label label--md">Фамилия</label>
                                            <input id="profile_name_1" className="input input--md js-focus-outside " type="text" name="name_1" value={personalInfo.name_1} disabled/>
                                            <div className="personal-form__error-message "></div>
                                        </div>
                                        <div className="form__item form__item--md">
                                            <label for="profile_name_2" className="label label--md">Имя</label>
                                            <input id="profile_name_2" className="input input--md js-focus-outside " type="text" name="name_2" value={personalInfo.name_2} disabled/>
                                            <div className="personal-form__error-message "></div>
                                        </div>
                                    </div>
                                    <div className="form__line">
                                        <div className="form__item form__item">
                                            <label for="profile_name_3" className="label label--md">Отчество</label>
                                            <input id="profile_name_3" className="input input--md js-focus-outside " type="text" name="name_3" value={personalInfo.name_3} disabled/>
                                            <div className="personal-form__error-message "></div>
                                        </div>
                                    </div>
                                    <div className="wysiwyg">
                                        <h4 className="title title--h4" style={{paddingTop: 30, paddingLeft: 25}}>Контактная информация</h4>
                                    </div>
                                    <div className="form__line">
                                        <div className="form__item form__item--md">
                                            <label for="card_phone" className="label label--md">Домашний телефон</label>
                                            <input id="card_phone" className="input input--md js-focus-outside " type="text" name="phone" value={personalInfo.phone} disabled/>
                                            <div className="personal-form__error-message"></div>
                                        </div>
                                        <div className="form__item form__item--md">
                                            <label for="card_mobile" className="label label--md">Мобильный телефон</label>
                                            <input id="card_mobile" className="input input--md js-focus-outside " type="text" name="mobile" value={personalInfo.mobile} disabled/>
                                            <div className="personal-form__error-message"></div>
                                        </div>
                                    </div>
                                    <div className="form__line">
                                        <div className="form__item form__item">
                                            <label for="card_email" className="label label--md">Email</label>
                                            <input id="card_email" className="input input--md js-focus-outside " type="text" name="email" value={personalInfo.email} disabled/>
                                            <div className="personal-form__error-message"></div>
                                        </div>
                                    </div>
                                    <div className="wysiwyg">
                                        <h4 className="title title--h4" style={{paddingTop: 30, paddingLeft: 25}}>Адрес установки оборудования</h4>
                                    </div>
                                    <div className="form__line">
                                        <div className="form__item form__item">
                                            <label for="address_region" className="label label--md">Регион</label>
                                            <input id="address_region" className="input input--md js-focus-outside " type="text" name="address_region" value={locations.map(item => (item.type_id === 1 ? item.value : '')).join('')} disabled/>
                                        </div>
                                    </div>
                                    <div className="form__line">
                                        <div className="form__item form__item">
                                            <label for="address_disctrict" className="label label--md">Район</label>
                                            <input id="address_disctrict" className="input input--md js-focus-outside " type="text" name="address_disctrict" value={locations.map(item => (item.type_id === 2 ? item.value : '')).join('')} disabled/>
                                        </div>
                                    </div>
                                    <div className="form__line">
                                        <div className="form__item form__item--md">
                                            <label for="" className="label label--md">Город</label>
                                            <input id="address_city" className="input input--md js-focus-outside " type="text" name="address_city" value={locations.map(item => (item.type_id === 3 ? item.value : '')).join('')} disabled/>
                                        </div>
                                        <div className="form__item form__item--md">
                                            <label for="address_locality" className="label label--md">Населенный пункт</label>
                                            <input id="address_locality" className="input input--md js-focus-outside " type="text" name="address_locality" value={locations.map(item => (item.type_id === 4 ? item.value : '')).join('')} disabled/>
                                        </div>
                                    </div>
                                    <div className="form__line">
                                        <div className="form__item form__item">
                                            <label for="address_address" className="label label--md">Адрес</label>
                                            <textarea id="address_address" className="textarea textarea--md js-focus-outside" disabled value={
                                                locations.map(item => ((item.type_id !== 1 && item.type_id !== 2 && item.type_id !== 3 && item.type_id !== 4) ? `${item.value}, ` : '')).join('').slice(0, -2)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div id='messageBanner' className="info-cards__message-container js-closing-banner is-active" style={{display: 'none'}}>
                                <div className="info-cards__message">
                                    <div className="info-cards__message-content">
                                        <HandySvg className="svg-icon" src={iconAttention} width="36" height="36"/>
                                        <div className="info-cards__message-text">{message}</div>
                                    </div>
                                    <button className="js-close-btn info-cards__message-btn" type="button">
                                        <HandySvg className="svg-icon" src={iconCross} width="13" height="12"/>
                                    </button>
                                </div>
                            </div>
			            </div>
                        <aside className="common-article__aside content-columns__aside" style={{marginTop: 50}}>
                            <div className="content-columns__aside-cell">
                                <Aside/>
                            </div>	
                            <div className="content-columns__aside-cell">
                                <div className="content-aside-widget page__area">
                                    <div className="content-aside-widget__header">
                                        <span className="content-aside-widget__label">Данные договора</span>
                                    </div>
                                    <div className="content-aside-widget__body">
                                        <h4 className="content-aside-widget__title">Изменение данных договора</h4>
                                        <div className="content-aside-widget__description">
                                            <p>Для смены личных данных по договору обращайтесь в службу поддержки.</p>
                                        </div>
                                        <div className="content-aside-widget__footer">
                                            <Link className="content-aside-widget__btn solid-btn solid-btn--pink solid-btn--md bttn" to='//telekarta.tv/contacts/'>Служба поддержки
                                                <HandySvg className="svg-icon solid-btn__arrow-right" src={iconPointerRight} width="19" height="10"/>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
	            </article>
            </div>
        </>
    );
};

export default ContractData;